import {
  CREATE_ANNOUNCEMENT_ALERT_SUCCESS,
  GET_ANNOUNCEMENT_ALERT_SUCCESS,
  DELETE_ANNOUNCEMENT_ALERT_SUCCESS,
  UPDATE_ANNOUNCEMENT_ALERT_SUCCESS,
  READ_ANNOUNCEMENT_ALERT_SUCCESS,
  GET_ANNOUNCEMENT_DETAIL_ALERT_SUCCESS,
  RESET_UPDATE_ANNOUNCEMENT_ALERT_DETAILS,
  GET_ANNOUNCEMENT_USER_DETAIL_ALERT_SUCCESS,
} from "../constants";
import { cloneDeep, remove } from "lodash";

export const initialState = {
  //courseAnnouncement
  courseAnnouncement: undefined,
  announcementsUser: undefined,
  courseAnnouncementdetail: undefined,
  read: false,
};

export const AdminAnnouncementReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_ANNOUNCEMENT_ALERT_SUCCESS:
      return {
        ...state,
        courseAnnouncement: action.payload,
      };

    case CREATE_ANNOUNCEMENT_ALERT_SUCCESS:
      return {
        ...state,
        courseAnnouncement: action.payload,
      };
    case GET_ANNOUNCEMENT_USER_DETAIL_ALERT_SUCCESS: {
      return {
        ...state,
        announcementsUser: action.payload,
      };
    }
    case UPDATE_ANNOUNCEMENT_ALERT_SUCCESS:
      // const tempAttendeeAddDetails = cloneDeep(state.courseAttendees);
      // tempAttendeeAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        courseAnnouncement: action.payload,
      };

    case READ_ANNOUNCEMENT_ALERT_SUCCESS:
      return {
        ...state,
        courseAnnouncement: action.payload,
        read: true,
      };

    case DELETE_ANNOUNCEMENT_ALERT_SUCCESS: {
      const tempAnnouncement = cloneDeep(state.courseAnnouncement);
      remove(tempAnnouncement.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        courseAnnouncement: tempAnnouncement,
      };
    }

    case GET_ANNOUNCEMENT_DETAIL_ALERT_SUCCESS: {
      return {
        ...state,
        courseAnnouncementdetail: action.payload,
      };
    }

    case RESET_UPDATE_ANNOUNCEMENT_ALERT_DETAILS:
      return {
        ...state,
        courseAnnouncementdetail: undefined,
      };
    default:
      return state;
  }
};
